import React, { useState, useEffect } from "react";
import ReactTooltip from "react-tooltip";
import styled from "styled-components";

// import Header from "./Header";
import Filters from "./Filters";
import Map from "./Map";
import Timeseries from "./Timeseries";
import Table from "./Table";
import Source from "./Source";

import microApi from "../helpers/microApi";
import Headline from "./Headline";

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 325px 1fr;
  grid-gap: 3rem;

  @media only screen and (max-width: 750px) {
    display: block;

    & > :first-child {
      margin-bottom: 5rem;
    }
  }
`;

const tableFacets = {
  us: {
    industry: {
      facet: "naics3_name",
      facetLabel: "3-Digit NAICS",
      exclude: "Unclassified Industry"
    },
    occupation: {
      facet: "soc5_name",
      facetLabel: "SOC",
      exclude: "Unclassified Occupation"
    }
  },
  ca: {
    industry: {
      facet: "naics3_name",
      facetLabel: "3-Digit NAICS",
      exclude: "[Unknown]"
    },
    occupation: {
      facet: "noc4_name",
      facetLabel: "NOC",
      exclude: "[Unknown]"
    }
  }
}

const FootnoteWrapper = styled.div`
  font-size: 11px;
  display: flex;
  flex-direction: row;
  border-top: 0.1px solid lightgray;
  border-bottom: 0.1px solid lightgray;
  box-sizing: border-box;
  padding: 5px 0;
  margin: 0 0 20px 0;
  
  > * {
    margin: 0;
    padding: 5px;
  }

  > :first-child {
    font-size: 18px;
  }
`

function Dashboard({ nation }) {
  const [latestDay, setLatestDay] = useState();
  const [tooltipContent, setTooltipContent] = useState("");

  useEffect(() => {
    const getLatestDay = async () => {
      const res = await microApi.get(`/${nation}/meta`);
      setLatestDay(res.data.data.latest_day);
    };
    getLatestDay();
  }, [nation]);

  const [filters, setFilters] = useState({});
  const [timeframe/*, setTimeframe*/] = useState("month");

  return (
    <div>
      {/* <Header {...{ timeframe, setTimeframe, latestDay }} /> */}
      <Wrapper>
        <Filters setFilters={setFilters} nation={nation} />
        {latestDay ? (
          <div>
            <Headline {...{ nation, filters, timeframe, latestDay }} />
            <Map {...{ nation, filters, timeframe, latestDay, setTooltipContent }} />
            <ReactTooltip
              textColor="#204354"
              backgroundColor="#fff"
              border
              borderColor="#d8d8d8"
            >
              {tooltipContent}
            </ReactTooltip>
            <FootnoteWrapper>
              <div>*</div>
              <p>
                This number represents unique job postings from companies looking to hire in the last 30 days.
                <br />
                Duplicate postings for the same job/company combination have been
                removed.
                <br />
                <br />
                Job postings data differs from job openings. While similar, job
                openings are a metric drawn from government sources measuring
                separations between payrolled employees and employers.
              </p>
            </FootnoteWrapper>
            <Timeseries {...{ nation, filters, timeframe, latestDay }} />
            <Table
              title="Industries"
              {...{ nation, filters, timeframe, latestDay, ...tableFacets[nation].industry }}
            />
            <Table
              title="Occupations"
              {...{ nation, filters, timeframe, latestDay, ...tableFacets[nation].occupation }}
            />
            <Source timeframe={timeframe} latestDay={latestDay} />
          </div>
        ) : null}
      </Wrapper>
    </div>
  );
}

export default Dashboard;
